import { getCurrentSubdomain } from './get-current-subdomain.ts';

export const initializeTheme = (): void => {
    const { subdomain } = getCurrentSubdomain();

    document.documentElement.setAttribute('data-theme', subdomain);
};
